/*
 * Copyright (c) 2026 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { Analytics } from '@vercel/analytics/react'

import { withoutClickIds } from '@/lib/analytics/vercel'

/**
 * Vercel Web Analytics, with ad click IDs removed from every URL it sends. A client component, because the layout
 * cannot pass the `beforeSend` function to a client component itself.
 */
export const VercelAnalytics = () => {
  return <Analytics beforeSend={withoutClickIds} />
}
